import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_STRING,
} from '@dat/datiq-core/models';

import {
    IDatiqTimelineNestedTab,
    IDatiqTimelineNestedTabGroup,
    IDatiqTimelineNested,
} from './datiq-timeline-nested.interface';

export const emptyDatiqTimelineNestedTab: IDatiqTimelineNestedTab = {
    value: DATIQ_DEFAULT_STRING,
    label: DATIQ_DEFAULT_EMPTY_LABEL,
};

export const emptyDatiqTimelineGroup: IDatiqTimelineNestedTabGroup = {
    id: DATIQ_DEFAULT_ID(),
    tabs: DATIQ_DEFAULT_ARRAY as IDatiqTimelineNestedTab[],
};

export const emptyDatiqTimelineNested: IDatiqTimelineNested = {
    groups: DATIQ_DEFAULT_ARRAY as IDatiqTimelineNestedTabGroup[],
};
